// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__pt8eZ","overlay":"modal_overlay__TtQGZ"};